import React from 'react';
import { Route } from 'react-router-dom';
const TeacherPostList = React.lazy(
  () => import('pages/teacherSide/post/TeacherPostList/TeacherPostList'),
);
const BoardPostWriteEdit = React.lazy(
  () => import('pages/teacherSide/post/BoardPostWriteEdit/BoardPostWriteEdit'),
);
const NotePostWriteEdit = React.lazy(
  () => import('pages/teacherSide/post/NotePostWriteEdit/NotePostWriteEdit'),
);
const TeacherPostDetail = React.lazy(
  () => import('pages/teacherSide/post/TeacherPostDetail/TeacherPostDetail'),
);

const TeacherPostReviewList = React.lazy(
  () => import('pages/teacherSide/post/TeacherPostReviewList/TeacherPostReviewList'),
);

const TeacherPostReviewDetail = React.lazy(
  () => import('pages/teacherSide/post/TeacherPostReviewDetail/TeacherPostReviewDetail'),
);

const RouteListTSPost = (
  <Route path="teacherSide/post/">
    {/* 목록 */}
    <Route path="generalBoard" element={<TeacherPostList target="generalBoard" />} />
    <Route path="classBoard" element={<TeacherPostList target="classBoard" />} />
    <Route path="note" element={<TeacherPostList target="note" />} />

    {/* 보기 */}
    <Route path="notePost/:postId" element={<TeacherPostDetail postType="notePost" />} />
    <Route path="boardPost/:postId" element={<TeacherPostDetail postType="boardPost" />} />

    {/* 검토 */}
    <Route path="review/">
      <Route path="mine" element={<TeacherPostReviewList scope="mine" />} />
      <Route path="inbox" element={<TeacherPostReviewList scope="inbox" />} />
      <Route
        path="mine/boardPost/:postId"
        element={<TeacherPostReviewDetail scope="mine" postType="boardPost" />}
      />
      <Route
        path="mine/notePost/:postId"
        element={<TeacherPostReviewDetail scope="mine" postType="notePost" />}
      />
      <Route
        path="inbox/boardPost/:postId"
        element={<TeacherPostReviewDetail scope="inbox" postType="boardPost" />}
      />
      <Route
        path="inbox/notePost/:postId"
        element={<TeacherPostReviewDetail scope="inbox" postType="notePost" />}
      />
    </Route>

    {/* 쓰기 */}
    <Route path="writeBoardPost" element={<BoardPostWriteEdit mode="write" />} />
    <Route path="writeNotePost" element={<NotePostWriteEdit mode="write" />} />
    <Route path="editBoardPost/:postId" element={<BoardPostWriteEdit mode="edit" />} />
    <Route path="editNotePost/:postId" element={<NotePostWriteEdit mode="edit" />} />
  </Route>
);

export default RouteListTSPost;
